(function($){

    function initServiceSlider() {
        $('.js-services-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            dots: false,
            arrows: true,
            infinite: true,
//            adaptiveHeight: true,
        });
        /**
         * FIX JUMPING ANIMATION
         * Set special animation class on first or last clone.
         */
        var $carousel = $('.js-services-slider');
        $carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var 
                direction,
                slideCountZeroBased = slick.slideCount - 1;

            if (nextSlide == currentSlide) {
                direction = "same";

            } else if (Math.abs(nextSlide - currentSlide) == 1) {
                direction = (nextSlide - currentSlide > 0) ? "right" : "left";

            } else {
                direction = (nextSlide - currentSlide > 0) ? "left" : "right";
            }

            // Add a temp CSS class for the slide animation (.slick-current-clone-animate)
            if (direction == 'right') {
                $('.slick-cloned[data-slick-index="' + (nextSlide + slideCountZeroBased + 1) + '"]', $carousel).addClass('slick-current-clone-animate');
            }

            if (direction == 'left') {
                $('.slick-cloned[data-slick-index="' + (nextSlide - slideCountZeroBased - 1) + '"]', $carousel).addClass('slick-current-clone-animate');
            }
        });

        $carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');
            $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');
        });
    }
    
	/* Document Ready */
	$(document).ready(function() {
        
        initServiceSlider();
        
	});
})(jQuery);